import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useDropzone } from 'react-dropzone';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Mixpanel } from "../mixpanel/mixpanel.js";
import React, { useEffect, useState } from 'react';
import UploadFormat from "../assets/UploadFormat.csv";
import DownloadIcon from '@mui/icons-material/Download';
import { CircularProgress, FormControl, FormHelperText, Grid, InputLabel, LinearProgress, MenuItem, Paper, Select, Tab, Tabs, TextField } from '@mui/material';

const style = {
    p: 3,
    top: '50%',
    left: '50%',
    width: "30%",
    boxShadow: 24,
    height: "auto",
    bgcolor: 'white',
    position: 'absolute',
    borderRadius: "10px",
    transform: 'translate(-50%, -50%)',
};

const StyledTabs = styled((props) => (
    <Tabs
        {...props}
        TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
    />
))({
    '& .MuiTabs-indicator': {
        display: 'flex'
    },
    '& .MuiTabs-indicatorSpan': {
        width: '100%',
        backgroundColor: '#000',
    },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
        textTransform: 'none',
        fontWeight: theme.typography.fontWeightLight,
        fontSize: theme.typography.pxToRem(15),
        marginRight: theme.spacing(1),
        color: 'rgba(0, 0, 0, 0.4)',
        '&.Mui-selected': {
            color: 'rgba(0, 0, 0, 1)',
        },
        '&.Mui-focusVisible': {
        },
    }),
);

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function CreateCampaign(props) {

    const handleCloseProp = props.handleClose;
    var userData = props.userData;


    function setTabLabel(label) {
        return (<div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "6px" }}>
            <Typography>{label}</Typography>
        </div>)
    }
    const tabLabels = [setTabLabel("Select From List"), setTabLabel("Import From CSV")]


    const [activeLists, setActiveLists] = useState([]);
    async function fetchAllLists() {

        const token2 = await userData.getIdToken()

        let listApiOptions = {
            method: 'GET',
            headers: new Headers({
                'Authorization': `Bearer ${token2}`,
                'Content-Type': "application/json"
            })
        }
        await fetch(process.env.REACT_APP_API_ADDRESS + '/api/fetch_all_lists', listApiOptions)
            .then(result => result.json())
            .then(body => { setActiveLists(body); });
    }

    useEffect(() => {
        fetchAllLists();
    }, []);

    const [campaignName, setCampaignName] = useState("")

    const handleCampaignName = event => {
        setCampaignName(event.target.value);
    };

    const [listId, setListId] = useState('');

    const handleChange = (event) => {
        var list_id = event.target.value;
        setListId(list_id)
    };


    const [isLoading, setIsLoading] = useState(false);

    async function createNewCampaign() {

        if (listId != '' && campaignName != "") {
            setIsLoading(true);
            const token2 = await userData.getIdToken()

            let data = {
                listId: listId,
                campaignName: campaignName
            }

            Mixpanel.identify(userData.email);
            Mixpanel.track('Campaign Created', { data });

            let createCampaignOptions = {
                method: 'POST',
                body: JSON.stringify(data),
                headers: new Headers({
                    'Authorization': `Bearer ${token2}`,
                    'Content-Type': "application/json"
                })
            }


            await fetch(process.env.REACT_APP_API_ADDRESS + '/api/create_new_campaign/', createCampaignOptions)
                .then(result => result.json())
                .then(body => { console.log("Create Campaign Res: " + body); setIsLoading(false); handleCloseProp() });
        }
        else { console.log("Please input campaign name") }
    };


    const [tabValue, setTabValue] = React.useState(0);

    const handleChangeTabs = (event, newValue) => {
        setTabValue(newValue);
    };


    const [uploadedFileName, setUploadedFileName] = useState('');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [fileToUpload, setFileToUpload] = useState(null);

    async function uploadFile() {
        setIsLoading(true);
        // Create a FormData object to send the file
        const formData = new FormData();

        // Append the Excel file to the FormData
        formData.append('file_path', fileToUpload);
        formData.append("campaignName", campaignName)

        // console.log("UPLOAD FILE CALLED")
        // console.log(fileToUpload)

        const token2 = await userData.getIdToken()

        let options = {
            method: 'POST',
            body: formData,
            headers: new Headers({
                'Authorization': `Bearer ${token2}`,
            })
        }


        await fetch(process.env.REACT_APP_API_ADDRESS + '/api/create_new_campaign_csv', options)
            .then((response) => {
                // Handle the API response here
                // console.log('API Response:', response);
                setIsLoading(false); handleCloseProp()
            })
            .catch((error) => {
                // Handle any errors here
                // console.log('API Error:', error);
            });
    };


    const onDrop = (acceptedFiles) => {
        const file = acceptedFiles[0];
        setUploadedFileName(file.name);

        // Simulate file upload progress (for demonstration purposes)
        let progress = 0;
        const interval = setInterval(() => {
            progress += 20;
            setUploadProgress(progress);

            if (progress >= 100) {
                clearInterval(interval);
                // uploadFile(file)
                setFileToUpload(file)
            }
        }, 100);
    };

    const { getRootProps, getInputProps } = useDropzone({
        accept: ['.xlsx', '.csv', 'text/csv'],
        onDrop
    });

    const dropzoneStyles = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        border: '2px dashed #cccccc',
        borderRadius: '4px',
        backgroundColor: '#f5f5f5',
        cursor: 'pointer',
        boxShadow: "none"
    };

    const [displayCampaignError, setDisplayCampaignError] = useState(false)
    const [listError, setListError] = useState(false)
    const [fileError, setFileError] = useState(false)

    function checkCampaignType(tabValue) {
        if (campaignName == "") {
            setDisplayCampaignError(true)
        } else {
            if (tabValue == 0) {
                if (listId == '') {
                    setDisplayCampaignError(false)
                    setListError(true)
                } else {
                    createNewCampaign()
                }
            } else if (tabValue == 1) {
                if (fileToUpload == null) {
                    setDisplayCampaignError(false)
                    setFileError(true)
                } else {
                    uploadFile()
                }
            }
        }
    }

    return (
        <Box sx={style}>
            <Grid container sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <Grid item>
                    <Typography variant="h6">
                        Enter Campaign Details
                    </Typography>
                </Grid>
                <Grid item sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                    <Typography>
                        Enter Campaign Name
                    </Typography>
                    <TextField
                        style={{ width: "100%", margin: "10px 10px 30px 0px" }}
                        required
                        placeholder="Campaign 1"
                        value={campaignName}
                        onChange={handleCampaignName}
                        error={displayCampaignError}
                        helperText={displayCampaignError ? "Please enter campaign name" : ""}
                    />
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', display: "flex", justifyContent: "space-evenly" }}>
                        <StyledTabs value={tabValue} onChange={handleChangeTabs} >
                            {tabLabels.map((value, index) => (
                                <StyledTab key={index} iconPosition="end" label={value} />
                            ))}
                        </StyledTabs>
                    </Box>
                    <CustomTabPanel value={tabValue} index={0} >
                        <Typography>
                            Select list
                        </Typography>
                        <FormControl fullWidth style={{ width: "100%", margin: "10px 0px 30px 0px" }} error={listError}>
                            <InputLabel>List Name</InputLabel>
                            <Select
                                value={listId}
                                onChange={handleChange}
                            >
                                {activeLists.map((value, index) => (
                                    <MenuItem key={index} value={value.listId}>{value.listName}</MenuItem>
                                ))}
                            </Select>
                            {listError && <FormHelperText>Please select a list</FormHelperText>}
                        </FormControl>
                    </CustomTabPanel>
                    <CustomTabPanel value={tabValue} index={1}>
                        <Box sx={{ marginBottom: "10px", display: "flex", justifyContent: "right" }}>
                            <a href={UploadFormat} download="UploadFormat.csv" target='_blank'>
                                <Button sx={{ color: "black" }} endIcon={<DownloadIcon />}>Download Format</Button>
                            </a>
                        </Box>
                        <Paper elevation={3} {...getRootProps()} style={dropzoneStyles}>
                            <input {...getInputProps()} />
                            {uploadProgress == 0 && <Typography component="div">
                                Drag or Drop your CSV file here
                            </Typography>}
                            {uploadProgress > 0 &&
                                <Typography>
                                    File Uploaded: {uploadProgress}%
                                </Typography>}
                        </Paper>
                        {fileError && <FormHelperText sx={{ color: "red" }}>Please upload your file</FormHelperText>}
                        <Typography variant="body1" style={{ marginTop: '16px' }}>
                            Uploaded File: {uploadedFileName}
                        </Typography>
                        <Box style={{ color: "#000", position: "relative" }}>
                            <LinearProgress
                                color='inherit'
                                variant="determinate"
                                value={uploadProgress}
                                style={{ marginTop: '16px', width: '100%' }}
                            />
                        </Box>
                    </CustomTabPanel>
                    {isLoading && <CircularProgress style={{ color: "black" }} size={50} />}
                    {!isLoading && <Button style={{ margin: "10px 10px 10px 0px", backgroundColor: "#E4F87F", color: "black", borderRadius: "5px", width: "100%", border: "1px solid #C4C4C4" }} onClick={() => checkCampaignType(tabValue)}>Create Campaign</Button>}
                </Grid>
            </Grid>
        </Box>
    )
}

export default CreateCampaign
